export const home = {
myReports: {
title: "Vos signalements",
},
meta: {
untitledJob: "Intervention sans titre",
noAssetLinked: "Aucun actif lié",
unassigned: "Non assigné",
emDash: "—",
},
aggregation: {
scheduledInspectionFallback: "Inspection planifiée",
jobOverdueSubtitle: "{{asset}} · Échéance {{date}}",
jobOverdueNoDate: "{{asset}} · En retard",
jobOverdueUnassigned: "Intervention en retard",
inspectionOverdueSubtitle: "{{asset}} · Était due le {{date}}",
requestOverdueSubtitle: "{{asset}} · Était due le {{date}}",
jobDueTodaySubtitle: "{{asset}} · Échéance aujourd'hui",
inspectionDueTodaySubtitle: "{{asset}} · Échéance aujourd'hui",
inspectionScheduledSubtitle: "{{asset}} · Planifiée le {{date}}",
jobInProgressSubtitle: "{{asset}} · En cours",
followOnApprovalSubtitle: "{{asset}} · Approbation de suivi",
completionReviewSubtitle: "{{asset}} · Vérification de fin de travaux",
scheduledBadge: "Planifiée",
inProgressBadge: "En cours",
approvalBadge: "Approbation",
requestSubtitle: "{{asset}} · Suivi",
followUpQueuePending: "Nouvelles",
followUpQueueAwaitingCustomer: "En attente du client",
followUpQueueApproved: "Approuvé",
followUpQueueScheduled: "Planifié",
followUpQueueConverted: "Travail lié",
followUpQueueRejected: "Refusé",
certificateActionsTitle: "Certificats à échéance",
certificateActionsEmpty: "Aucun certificat à échéance",
certificatePendingValidation: "En attente de validation",
certificateRejected: "Rejeté",
certificateExpired: "Expiré",
certificateExpiringSoon: "Expire bientôt",
},
greeting: {
morning: "Bonjour",
afternoon: "Bon après-midi",
evening: "Bonsoir",
withName: "{{greet}}, {{name}}",
},
screen: {
title: "Accueil",
loadingCommandCenter: "Chargement de l’accueil…",
},
summaryStrip: {
assets: "Actifs",
openJobs: "Interventions ouvertes",
dueToday: "Pour aujourd'hui",
requests: "Demandes",
},
commandQuickActions: {
scanQr: "Scanner le QR",
},
commandEmpty: {
dueToday: "Rien n'est prévu aujourd'hui.",
needsAttention: "Rien n'appelle votre attention pour le moment.",
requests: "Pas encore de demandes. Les demandes d'actifs partagés apparaîtront ici.",
recentActivity: "Aucune activité récente.",
},
commandSectionTitles: {
overdue: "En retard",
dueToday: "Pour aujourd'hui",
requests: "Demandes",
recentActivity: "Activité récente",
},
commandCenter: {
statusBar: {
actionRequired: "Action requise",
needsAttention: "Nécessite votre attention",
allSystemsNormal: "Tout est normal",
synced: "Synchronisé {{label}}",
},
aiBriefing: {
label: "Briefing opérationnel",
readMore: "Lire le résumé →",
},
attentionQueue: {
title: "À traiter",
empty: "Boîte vide. Rien ne réclame votre attention pour l'instant.",
showMore: "{{count}} de plus →",
snooze: "Reporter",
kind: {
request: "Demandes",
inspection: "Inspections",
job: "Interventions",
document: "Documents",
activity: "Activité",
},
},
counters: {
dueInspections: "Inspections dues",
openRequests: "Demandes ouvertes",
openJobs: "Interventions ouvertes",
workQueue: "File de travail",
},
recentActivity: {
title: "Activité récente",
defaultEmpty: "Aucune activité aujourd'hui.",
events_one: "{{count}} événement",
events_many: "{{count}} événements",
events_other: "{{count}} événements",
},
},
empty: {
firstAssetTitle: "Créez votre premier actif",
firstAssetSubtitle: "Ajoutez un actif pour lancer des inspections et gérer le travail.",
noAssetsInScopeTitle: "Aucun actif dans {{scope}}",
noAssetsInScopeSubtitle: "Modifiez le filtre de portée ci-dessus ou ajoutez des actifs à cette équipe.",
noAssetsInScopeSubtitleWeb: "Modifiez le filtre de portée ou effacez la recherche — les actifs correspondants s’affichent ici.",
noAssetsInScopeShortWeb: "Changez la portée ou ajoutez des actifs à cette équipe.",
addAsset: "Ajouter un actif",
},
planNudge: {
asset_cap_limited: "Il reste un actif sur votre forfait ({{limit}} inclus). {{plan}} en inclut {{nextLimit}}.",
asset_cap: "Il vous reste un actif sur votre forfait ({{limit}} inclus). {{plan}} n'a pas de limite.",
same_contact: "Vous avez envoyé {{count}} interventions à {{name}} ce mois-ci. Avec {{plan}}, cette personne les voit et les met à jour elle-même.",
addresses: "Vos actifs sont répartis sur {{count}} adresses. Les sites, avec {{plan}}, regroupent le travail par lieu.",
inspections: "{{count}} inspections en une semaine, c'est beaucoup pour une seule personne. Les équipes, avec {{plan}}, se partagent la charge.",
seePlans: "Voir {{plan}}",
dismiss: "Pas maintenant",
},
teamSetup: {
title: "Configurez votre équipe",
dismiss: "Masquer la configuration de l'équipe",
steps: {
invite: "Inviter un coéquipier",
site: "Ajouter un site",
requests: "Laisser d'autres personnes signaler du travail (partager un actif)",
},
},
firstRun: {
progress: "{{completed}} sur {{total}} terminées",
gettingStartedDefault: "Pour commencer",
dismissDefault: "Masquer « Pour commencer »",
trySampleDefault: "Essayer un exemple",
removeSampleDefault: "Supprimer l’exemple",
title: "Pour commencer",
subtitle: "Touchez une étape. Chacune vous montre exactement où toucher.",
trySample: "Essayer l’exemple",
removeSample: "Supprimer l’exemple",
createAsset: "Créer un actif",
startInspection: "Démarrer une inspection",
dismiss: "Plus tard",
whatIsThis: "Qu’est-ce que c’est ?",
whatIsThisBody: "AssetWRX réunit vos actifs, inspections et interventions au même endroit, pour savoir toujours quoi faire ensuite.",
busy: "Préparation…",
error: "Impossible de préparer l’exemple. Vous pouvez toujours créer un actif manuellement.",
suggested: "Suggéré",
steps: {
  document: "Ajoutez un certificat",
asset: "Ajoutez votre premier actif",
request: "Partagez un actif avec quelqu’un",
inspection: "Planifiez une inspection",
job: "Créez une intervention",
contacts: "Invitez un collègue",
contactsNoTeams: "Ajoutez un contact",
},
coachmark: {
title: "Commencez ici",
body: "Touchez une étape pour commencer. Dans l’ordre que vous voulez.",
dismiss: "Compris",
},
},
web: {
commandOverline: "Trouver et créer",
commandHint: "Recherchez dans l’espace de travail, définissez la portée ou ajoutez des actifs, des interventions et des inspections.",
searchPlaceholder: "Rechercher des actifs, interventions, inspections, rapports…",
overviewTitle: "Vue d’ensemble",
overviewHint: "Raccourcis et compteurs en direct pour votre portée. Touchez une tuile KPI pour la liste complète.",
overviewSnapshotLabel: "Instantané",
overviewSnapshotHintWeb: "Actifs · Inspections · Interventions — touchez une tuile pour ouvrir cette liste.",
suggestedActionsTitle: "Actions suggérées",
suggestedActionsHint: "Priorités par règles dans cette portée. Ouvrez une carte pour aller à la bonne liste ou intervention.",
workQueueTitle: "File de travail",
workQueueHint: "Interventions et inspections priorisées pour cette portée. Sélectionnez une ligne pour voir les détails.",
activeWorkQueueTitle: "File de travail active",
workQueueSectionMeta: "Interventions, inspections et planifications — filtrez ou ouvrez une ligne pour les détails.",
queueEmptyNoItems: "Aucune intervention ou inspection à traiter dans cette portée.",
queueEmptyNoFilter: "Aucun élément ne correspond à ce filtre.",
automationHint: "Conversions, suggestions d’interventions par règles à partir des inspections terminées, et invitations d’équipe.",
detailJobTitle: "Détails de l’intervention",
detailOverviewTitle: "Vue d’ensemble",
detailEmpty: "Pas encore d’éléments dans cette portée. Utilisez Création rapide dans l’en-tête pour commencer.",
detailCommandSummary: "Synthèse",
detailIdleLead: "Sélectionnez une ligne dans la file pour les détails, actions principales et activité récente.",
detailStatOpenJobs: "Interventions ouvertes",
detailStatOverdue: "En retard",
detailStatUnassigned: "Non assigné",
detailNextUp: "Suivant dans la file",
viewAssetDetailsA11y: "Voir tous les détails de l’actif",
scheduleWorkA11y: "Planifier le travail",
moreActions: "Plus d’actions",
moreActionsA11y: "Plus d’actions",
copilotSectionTitle: "Assistant opérations",
copilotEmptyTitle: "Aucun signal prioritaire",
copilotEmptyBody: "Rien d’urgent dans cette portée pour l’instant. Ajustez les filtres, ajoutez du travail ou consultez Analytique et Travail.",
copilotDockHint: "Priorités par règles pour votre portée. Chaque carte renvoie vers la bonne liste ou intervention.",
},
snapshot: {
inspectionsSublabelDrafts: "Brouillons et en pause",
inspectionsSublabelScheduled_one: "Brouillons et en pause · {{count}} planifiée",
inspectionsSublabelScheduled_other: "Brouillons et en pause · {{count}} planifiées",
jobsSublabelNotClosed: "Non clos",
jobsSublabelOverdue_one: "Non clos · {{count}} en retard",
jobsSublabelOverdue_other: "Non clos · {{count}} en retard",
inThisScope: "Dans cette portée",
findingsSublabel: "Rapports terminés avec éléments en échec",
unassignedSublabel: "Interventions ouvertes sans responsable",
inspectionsSublabelScheduled_many: "Brouillons et en pause · {{count}} planifiées",
jobsSublabelOverdue_many: "Non clos · {{count}} en retard",
},
queueFilter: {
all: "Tout le travail",
overdue: "En retard",
inProgress: "En cours",
dueSoon: "Bientôt dû",
},
queue: {
labels: {
asset: "Actif",
due: "Échéance",
status: "Statut",
assignee: "Assigné à",
scheduled: "Planifié",
nextStep: "Prochaine étape",
started: "Démarré",
priority: "Priorité",
created: "Créé",
location: "Lieu",
dueDate: "Date d’échéance",
},
status: {
overdue: "En retard",
due: "Dû",
paused: "En pause",
inProgress: "En cours",
awaitingSchedule: "En attente de planification",
unassigned: "Non assigné",
},
subtitle: {
overdue: "{{asset}} • En retard",
activeWork: "{{asset}} • Travail actif",
dueThisWeek: "{{asset}} • Dû cette semaine",
scheduledInspection: "{{asset}} • Inspection planifiée",
needsSchedule: "{{asset}} • Planification requise",
unassigned: "{{asset}} • Non assigné",
resumeChecklist: "{{asset}} • Reprendre la liste",
},
title: {
inspectionOverdue: "Inspection en retard",
inspectionDue: "Inspection à échéance",
inspectionInProgress: "Inspection en cours",
},
typeJob: "Intervention",
typeInspection: "Inspection",
primaryOpenJob: "Ouvrir l’intervention",
primaryResumeInspection: "Reprendre l’inspection",
primaryStartInspection: "Démarrer l’inspection",
openWork: "Ouvrir le travail",
nextStepSetSchedule: "Définir la date et l’heure",
nextStepAssign: "Assigner équipe ou entrepreneur",
},
sections: {
quickActions: "Actions rapides",
quickActionsCardTitle: "Raccourcis",
quickActionsHintSetup: "Scanner et créer du travail.",
quickActionsHintFull: "Scanner, créer du travail et accéder aux éléments urgents.",
snapshot: "Instantané",
snapshotHint: "Actifs · Inspections · Interventions — touchez pour ouvrir",
myWork: "Mon travail",
myWorkHint: "Poursuivre, assigner ou terminer ce que vous gérez.",
needsAttention: "À traiter",
needsAttentionHint: "Groupé par type — mêmes éléments, lecture plus facile.",
workflowSuggestions: "Suggestions de workflow",
workflowHint: "Résultats du workflow d’inspection prêts pour la suite.",
viewAll: "Tout voir",
attentionQueue: "Attention",
attentionQueueCollapsedHint: "Appuyez pour développer la répartition complète des priorités",
attentionQueueShowLess: "Réduire",
attentionEmpty: "Aucun travail urgent dans ce périmètre.",
moreToolsTitle: "Plus d'outils",
moreToolsBody: "Analytique, fil d’activité complet et l’établi.",
contractorInvitesBanner_one: "Vous avez une invitation à chiffrer ou à réaliser un travail — touchez pour répondre",
contractorInvitesBanner_other: "Vous avez {{count}} invitations à chiffrer ou à réaliser des travaux — touchez pour répondre",
workspaceDeeperTitle: "Autres signaux",
workspaceDeeperSummary: "Planifications, travail actif et activité.",
commandShortcutsTitle: "Créer ou ouvrir",
commandShortcutsSummary: "Ajoutez du travail ou ouvrez la prochaine file.",
jumpToTitle: "Ouvrir",
jumpToSummary: "Registres et rapports.",
contractorInvitesBanner_many: "Vous avez {{count}} invitations à chiffrer ou à réaliser des travaux — touchez pour répondre",
},
welcome: {
subtitleDefault: "Travail du jour",
subtitleRecipient: "Des rapports et interventions partagés nécessitent votre réponse",
},
kpiStrip: {
pendingReviews: "Vérifications",
pendingReviewsSub: "En attente de votre réponse",
complianceSub: "Documents et inspections en retard",
},
attentionGroups: {
approvals: "Approbations et revues",
people: "Personnes et réponses",
time: "Temps et risque",
},
tasks: {
jobInvitations: {
title: "Invitations à des interventions",
sub: "Accepter ou refuser",
},
yourTurn: {
title: "À votre tour",
sub: "Accepter ou refuser l’intervention",
},
reworkRequested: {
title: "Reprise demandée",
sub: "Réassigner l’intervention",
},
workInProgress: {
title: "Travail en cours",
sub: "Terminer ou publier une mise à jour",
},
scheduleProposed: {
title: "Planification proposée",
sub: "Définir date et heure",
},
approvedRepairs: {
title: "Réparations approuvées",
sub: "Créer des interventions",
},
unassignedWork: {
title: "Travail non assigné",
sub: "Assigner équipe ou entrepreneur",
},
draftInspection: {
title: "Inspection brouillon",
sub: "Reprendre",
},
inspectionDue: {
title: "Inspection à échéance",
sub: "En retard ou 60+ jours",
},
criticalIssues: {
title: "Problèmes critiques",
sub: "État de santé faible",
},
followOnProposed: {
title: "Suivi proposé",
sub: "Approuver ou rejeter avant assignation",
},
completionSubmitted: {
title: "Achèvement soumis",
sub: "Approuver ou demander une reprise",
},
reportAwaitingReview: {
title: "Rapport en attente de revue",
sub: "Approuver ou refuser les réparations",
},
awaitingRecipient: {
title: "En attente du destinataire",
sub: "Revue",
},
awaitingRecipientResponse: {
title: "En attente de réponse",
sub: "Suivre et relancer les revues en attente",
},
overdueJobs: {
title: "Interventions en retard",
sub: "Débloquer le travail bloqué",
},
},
pinned: {
scanQr: "Scanner QR",
inspect: "Inspecter",
createJob: "Créer une intervention",
},
contextual: {
reviewReport: "Revoir le rapport",
respondToAssignment: "Répondre à l’assignation",
approveFollowOn: "Approuver le suivi",
approveCompletion: "Approuver l’achèvement",
continueJob: "Poursuivre l’intervention",
resumeInspection: "Reprendre l’inspection",
addAsset: "Ajouter un actif",
},
webQuickCreate: {
createInspection: "Créer une inspection",
createTemplate: "Créer une check-list",
createJob: "Créer une intervention",
scheduleWork: "Planifier le travail",
shortAsset: "Actif",
shortRequest: "Demande",
shortInspection: "Inspecter",
shortJob: "Intervention",
},
kpi: {
assets: "Actifs",
inspections: "Inspections",
jobs: "Interventions",
unassigned: "Non assigné",
findings: "Constats",
},
automation: {
approvedRepairsTitle: "Réparations approuvées",
suggestedJobsTitle: "Interventions de suivi issues de l’inspection",
teamInvitesTitle: "Invitations d’équipe",
},
urgency: {
critical: "Critique",
medium: "Moyen",
low: "Faible",
},
priorityDot: {
a11y: "Priorité {{level}}",
level: {
p1: "critique",
p2: "moyenne",
p3: "faible",
none: "aucune",
},
},
workLanes: {
kindLabel: {
request: "Demandes",
inspection: "Inspections",
job: "Interventions",
},
kindLabelLower: {
request: "demandes",
inspection: "inspections",
job: "interventions",
},
empty: "Rien n’a besoin de vous ici.",
viewAll: "Voir les {{count}} {{kind}} →",
},
assetGroups: {
overdueBadge_one: "{{count}} en retard",
overdueBadge_many: "{{count}} en retard",
overdueBadge_other: "{{count}} en retard",
needsYouBadge: "{{count}} pour vous",
openAssetMore: "Ouvrir l’actif · {{count}} de plus →",
openAsset: "Ouvrir l'actif →",
moreAssets_one: "{{count}} actif supplémentaire avec du travail ouvert",
moreAssets_other: "{{count}} actifs supplémentaires avec du travail ouvert",
moreAssets_many: "{{count}} actifs supplémentaires avec du travail ouvert",
},
sharedAssets: {
invitesA11y_one: "{{count}} invitation d'actif — accepter ou refuser",
invitesA11y_other: "{{count}} invitations d’actifs — accepter ou refuser",
invitesTitle_one: "Un actif a été partagé avec vous",
invitesTitle_other: "{{count}} actifs ont été partagés avec vous",
tapToAcceptOrDecline: "Appuyez pour accepter ou refuser",
activeA11y: "{{name}} — partagé avec vous. Ouvrir pour signaler un problème ou voir son travail.",
activeSub: "Partagé avec vous · Signaler un problème ou voir son travail",
invitesA11y_many: "{{count}} invitations d’actifs — accepter ou refuser",
invitesTitle_many: "{{count}} actifs ont été partagés avec vous",
},
sectionCard: {
otherGroup: "Autre",
emptyDefault: "Rien ici pour l'instant",
},
commandCentre: {
  showMeHow: "Me montrer comment",
calendar: "Calendrier",
stateLabel: {
actionNeeded: "Action nécessaire",
watch: "À surveiller",
active: "En cours",
clear: "Rien à signaler",
},
eyebrow: {
needsYou: "Besoin de vous",
now: "Maintenant",
decision: "Décision",
},
onYourPlate: "À faire",
watchlist: "À surveiller",
upNext: "Suivant",
portfolioMovement: "Ce qui a changé",
workspaceSummary: "Résumé de l’espace de travail",
toMonitor: "{{count}} à vérifier",
seeAll: "Voir tout",
seeAllA11y: "Tout voir ({{count}})",
assetRowA11y: "{{name}}. {{state}}. {{reason}}",
signalLabels: {
needsYou: "Besoin de vous",
atRisk: "À risque",
inMotion: "Actifs",
dueSoon: "Échéance proche",
},
viewDetails: "Voir les détails",
moreOnAsset_one: "{{count}} de plus sur {{name}} nécessite la même décision",
moreOnAsset_other: "{{count}} de plus sur {{name}} nécessitent la même décision",
moreOnAssetA11y_one: "{{count}} de plus sur {{name}} nécessite la même décision. Ouvrir dans Travail",
moreOnAssetA11y_other: "{{count}} de plus sur {{name}} nécessitent la même décision. Ouvrir dans Travail",
signalRowA11y: "{{action}} : {{name}}. {{reason}}",
moreOnAsset_many: "{{count}} de plus sur {{name}} nécessitent la même décision",
moreOnAssetA11y_many: "{{count}} de plus sur {{name}} nécessitent la même décision. Ouvrir dans Travail",
},
decisionModel: {
action: {
confirm: "Confirmer",
reply: "Répondre",
review: "Examiner",
resolve: "Résoudre",
createWork: "Créer un travail",
resubmit: "Soumettre à nouveau",
inviteMore: "Inviter plus",
respond: "Répondre",
open: "Ouvrir",
quote: "Faire un devis",
triage: "Décider",
resume: "Reprendre",
start: "Démarrer",
continueJob: "Continuer",
inspect: "Inspecter",
},
reason: {
overdue: "Les travaux en retard nécessitent une attention particulière",
blocked: "Les travaux sont bloqués et nécessitent une décision",
doneConfirmWithName: "{{name}} a marqué cela comme terminé - confirmez le correctif",
doneConfirm: "Le travail est terminé — confirmez le correctif",
visitConfirmWithName: "{{name}} a planifié une visite — confirmez que quelqu'un peut être là ou demandez une autre heure",
visitConfirm: "Une visite est prévue — confirmez que quelqu'un peut être là ou demandez une heure différente",
needMoreInfo: "L'équipe a besoin de plus d'informations de votre part",
waitingYourReview: "En attente de votre examen",
waitingYourReviewWithName: "{{name}} attend votre avis",
reviewWaiting: "Un examen ou une approbation est en attente",
approvedNoWorkYet: "Approuvé — le travail n’a pas encore été créé",
reworkSentBackWithName: "Renvoyé à {{name}} pour retravailler – en attendant qu'il le termine à nouveau",
reworkSentBack: "Renvoyé pour retravailler — en attendant qu'il soit à nouveau terminé",
reworkOwnerRedo: "Renvoyé pour retravailler — refaire le travail et le terminer à nouveau",
quotesDeclined: "Toutes les personnes invitées ont refusé de proposer un devis — invitez davantage d'entrepreneurs",
waitingRequesterConfirm: "En attente que le demandeur confirme le correctif",
acceptOrDeclineYou: "Attribué à vous — accepter ou refuser avant le début des travaux",
waitingAcceptWithName: "En attente de l'acceptation ou du refus de {{name}}",
waitingAccept: "En attente de l’acceptation ou du refus du responsable",
waitingTriageWithName: "{{name}} attend une décision",
waitingTriage: "Un demandeur attend une décision",
workspaceUnavailable: "Impossible de charger votre espace de travail. Touchez pour réessayer.",
dueToday: "Échéance aujourd'hui",
invitedToQuote: "Invité à proposer un devis — répondez avec un prix ou refusez",
pausedWithReason: "En pause — {{reason}}. Reprenez quand vous le pouvez",
pausedResume: "En pause — reprenez lorsque vous le pouvez",
onThisJob: "Vous êtes sur cette intervention — terminez-la lorsque le travail est fini",
assignedStartOnSite: "Attribué à vous — commencez lorsque vous êtes sur site",
scheduledApproaching: "Les travaux programmés approchent",
pausedWithReasonOnly: "En pause — {{reason}}",
paused: "En pause",
inProgress: "Les travaux sont en cours",
fallback: "Une attention opérationnelle est requise",
},
assetReason: {
actionRequired: "Une action est requise",
criticalRisk: "Risque critique sur l’actif",
elevatedRisk: "Risque élevé sur l’actif",
operationalConcern: "Problème opérationnel",
activeOrScheduled: "Le travail est actif ou planifié",
noException: "Rien ne demande d’attention",
},
assetWatchSignal: {
criticalMonitor: "Le risque critique sur l’actif nécessite une surveillance",
elevatedMonitor: "Le risque élevé des actifs nécessite une surveillance",
conditionNeedsAction: "L'état nécessite une action",
},
brief: {
itemsNeed_one: "{{count}} élément nécessite une attention particulière.",
itemsNeed_other: "{{count}} éléments nécessitent une attention particulière.",
conditionsWatchClause_one: " {{count}} autre à surveiller.",
conditionsWatchClause_other: " {{count}} autres à surveiller.",
nothingNeedsYou: "Rien n’a besoin de vous pour le moment.",
watchlist_one: "Rien ne nécessite votre attention pour le moment. {{count}} point à surveiller.{{motion}}",
watchlist_other: "Rien ne nécessite votre attention pour le moment. {{count}} points à surveiller.{{motion}}",
inMotionOnly_one: "Rien ne nécessite votre attention pour le moment. {{count}} élément est planifié ou en cours.",
inMotionOnly_other: "Rien ne nécessite votre attention pour le moment. {{count}} éléments sont planifiés ou en cours.",
invitationsOnly_one: "{{count}} invitation à chiffrer ou à réaliser un travail attend votre réponse.",
invitationsOnly_other: "{{count}} invitations à chiffrer ou à réaliser des travaux attendent votre réponse.",
invitationsOnly_many: "{{count}} invitations à chiffrer ou à réaliser des travaux attendent votre réponse.",
inMotionClause_one: " {{count}} élément est planifié ou en cours.",
inMotionClause_other: " {{count}} éléments sont planifiés ou en cours.",
itemsNeed_many: "{{count}} éléments nécessitent une attention particulière.",
conditionsWatchClause_many: " {{count}} autres à surveiller.",
watchlist_many: "Rien ne nécessite votre attention pour le moment. {{count}} points à surveiller.{{motion}}",
inMotionOnly_many: "Rien ne nécessite votre attention pour le moment. {{count}} éléments sont planifiés ou en cours.",
inMotionClause_many: " {{count}} éléments sont planifiés ou en cours.",
},
},
copilot: {
overdue: {
title: "Travail en retard",
body_one: "{{count}} intervention ouverte avec une échéance passée. Planifiez-la ou clôturez-la en priorité.",
body_other: "{{count}} interventions ouvertes avec une échéance passée. Planifiez-les ou clôturez-les en priorité.",
action: "Ouvrir les interventions",
body_many: "{{count}} interventions ouvertes avec une échéance passée. Planifiez-les ou clôturez-les en priorité.",
},
failedFindings: {
title: "Constats d’inspection",
body_one: "{{count}} inspection terminée dans cette portée comporte des éléments en échec. Convertissez les constats critiques en interventions quand vous êtes prêt.",
body_other: "{{count}} inspections terminées dans cette portée comportent des éléments en échec. Convertissez les constats critiques en interventions quand vous êtes prêt.",
action: "Inspections",
body_many: "{{count}} inspections terminées dans cette portée comportent des éléments en échec. Convertissez les constats critiques en interventions quand vous êtes prêt.",
},
throughput: {
title: "Rythme d’achèvement",
bodyUp: "Les achèvements vérifiés ont accéléré sur la seconde moitié des {{days}} derniers jours.",
bodyDown: "Les achèvements vérifiés ont ralenti sur la seconde moitié des {{days}} derniers jours. Vérifiez les blocages.",
action: "File de travail",
},
unassigned: {
title: "Couverture des assignations",
body_one: "{{count}} intervention ouverte n’a pas d’assigné. Assignez des responsables pour améliorer la responsabilisation.",
body_other: "{{count}} interventions ouvertes n’ont pas d’assigné. Assignez des responsables pour améliorer la responsabilisation.",
action: "Interventions",
body_many: "{{count}} interventions ouvertes n’ont pas d’assigné. Assignez des responsables pour améliorer la responsabilisation.",
},
assetHealth: {
title: "Actifs en difficulté",
body_one: "{{count}} actif dans cette portée se situe dans la tranche de santé faible (travail ouvert, constats ou obsolescence).",
body_other: "{{count}} actifs dans cette portée se situent dans la tranche de santé faible (travail ouvert, constats ou obsolescence).",
action: "Actifs",
body_many: "{{count}} actifs dans cette portée se situent dans la tranche de santé faible (travail ouvert, constats ou obsolescence).",
},
allClear: {
title: "Instantané des opérations",
body: "Aucun signal Copilot urgent dans cette portée sur les {{days}} derniers jours. Consultez les graphiques et maintenez les assignations.",
},
},
copilotCards: {
  sync: {
    body_many: "{{count}} modifications enregistrées sur cet appareil attendent d’être envoyées.",
    primary: "Voir les modifications",
    body_other: "{{count}} modifications enregistrées sur cet appareil attendent d’être envoyées.",
    body_one: "1 modification enregistrée sur cet appareil attend d’être envoyée.",
    title: "Modifications pas encore envoyées",
  },
  requests: {
    title_many: "{{count}} demandes urgentes à examiner",
    primary: "Voir les demandes",
    body: "Ouvrez les demandes pour voir leur urgence et les transformer en travail.",
    title_other: "{{count}} demandes urgentes à examiner",
    title_one: "1 demande urgente à examiner",
  },
  brief: {
    draft: "Rédige le plan du jour pour {{overdue}} éléments en retard et {{today}} prévus aujourd’hui. Mets d’abord ce qui est urgent et reste bref.",
    primary: "Proposer un plan",
    body: "{{overdue}} en retard et {{today}} pour aujourd’hui. L’assistant peut les classer.",
    title: "Planifier la journée",
  },
},
syncBanner: {
pending_one: "Synchronisation en attente : {{count}} modification hors ligne attend une nouvelle tentative.",
pending_many: "Synchronisation en attente : {{count}} de modifications hors ligne attendent une nouvelle tentative.",
pending_other: "Synchronisation en attente : {{count}} modifications hors ligne attendent une nouvelle tentative.",
},
healthEntries: {
ok: "OK",
syncLabel: "Synchronisation",
syncPending_one: "{{count}} en attente",
syncPending_many: "{{count}} en attente",
syncPending_other: "{{count}} en attente",
syncUpToDate: "À jour",
failedSyncsLabel: "Synchronisations échouées",
failedSyncsCount_one: "{{count}} échouée",
failedSyncsCount_many: "{{count}} échouées",
failedSyncsCount_other: "{{count}} échouées",
iotLabel: "IoT",
iotCount_one: "{{count}} avertissement",
iotCount_many: "{{count}} d’avertissements",
iotCount_other: "{{count}} avertissements",
iotTitle: "Avertissements IoT",
iotEmpty: "Aucun avertissement IoT.",
},
};
